<template>
    <div class="rule-box">
        <div class="content">
            <div class="main-content">
                <div class="content-text">
                    <p>一、活动预热期：2023年2月9日00:00 – 2023年2月14日23:59</p>
                    <p>二、活动当天：2023年2月14日00:00 – 2023年2月14日23:59</p>
                    <p>三、活动玩法：</p>
                    <p>1. 用户在活动预热期间可以领取/购买优惠券或优惠券包；</p>
                    <p>2. 具体使用日期以券面为准；</p>
                    <p>3. 活动结束后，系统会对未使用的优惠券订单自动退款。</p>
                    <p>四、优惠券介绍：</p>
                    <p>1. 本次活动共包括两种券：免费领取和需购买的美食券；</p>
                    <p>2. 活动内所获优惠券限在百度地图APP使用，可抵扣相关费用；</p>
                    <p>3. 活动期间，每种券每个用户只能购买/领取一次，券仅限一次性使用，不可拆分、不可转让、不可提现；</p>
                    <p>4. 用户须在活动当天使用优惠券，过期未使用则不可使用，用户可申请退款，活动结束后，系统会对未使用的优惠券订单自动退款；</p>
                    <p>5. 查看优惠券及订单方式：【百度地图-活动页-订单/我的券包】。</p>
                    <p>五、开票事宜：</p>
                    <p>购买优惠券费用，用户可联系百度地图客服进行开具；购买美食套餐费用，用户可直接联系商家或美团索要发票。</p>
                    <p>六、活动特别声明：</p>
                    <p>1. 此活动需要升级至最新版本的百度地图；</p>
                    <p>2. 每个账号、设备号、手机号关联的地图账号视为一个用户，同一用户使用多个账号，或同一个账号登录多台手机，会被视为作弊，将会导致无法参与活动；</p>
                    <p>3. 对于通过系统漏洞，虚假操作，黑客工具，作弊工具等非正当手段参与活动的用户，百度地图有权取消其参与活动和获奖的资格，冻结或撤销其已获得的奖励（包括已使用的和未使用的）;</p>
                    <p>4. 活动期间，请您保持手机适网状态，如因用户所在地区网络故障、支付平台网络不畅、
                        电信运营商故障等非百度所能控制的原因可能导致无法顺畅参与活动,百度地图不负法律或经济责任；如导致本活动无法继续举办的，百度地图有权决定暂停或终止本活动；</p>
                    <p>5. 活动期间用户误删或卸载客户端，有可能导致已领取的奖品信息丢失，请谨慎操作；</p>
                    <p>6. 第三方通过技术手段恶意攻击或篡改可能会致使中奖信息发生错误等情况，领取奖励的结果以“百度地图-活动页-我的券包”记录为准；</p>
                    <p>7. 百度公司对本活动内容享有修订权，并可在法律规定范围内对活动规则进行解释。</p>
                    <p>8. 百度地图不会采用电话/短信联系方式通知中奖信息，如遇以本活动名义为由收取各种税金或者要求缴费等的电话或短信，请勿采信。</p>
                    <p>9. 如您有任何疑问，可以联系百度地图客服，或者通过如下方式与我们联系：4000-998-998。</p>

                </div>
            </div>
            <div class="service" @click.stop="junmToService"></div>
        </div>
        <div class="closeBtn" @click="closeDialogBtn"></div>
    </div>
</template>

<script>
import common from '@/common/utils/com.js';

export default {
    methods: {
        // 关闭弹窗
        closeDialogBtn() {
            this.$emit('listenToChildEvent');
        },
        // 透明壳返回端内
        backToNativeWithTransparent(url) {
            const openapi
                = 'baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRooot=no&hiddenBackBtn=0&hiddenTitle=1&url='
                    + encodeURIComponent(url);
            const options = {
                launchInNA: true, // 是否调起地图, 默认调起
                openapi: openapi, // 默认用cost_share调起当前页面
                // isDuer: false, // 度口令打开
                immediately: false // 若调起客户端失败，是否立即执行失败回调。默认2s后执行失败回调
            };
            common.openMapClient(options);
        },
        junmToService() {
            // 点击客服调起端
            let url
                = 'baidumap://map/showfeedback?source=1&contactEnable=1&robotEnable=1&faqChannel=1&popRoot=no&src=school-season';
            let urlBack = window.location.origin + window.location.pathname;
            if (common.plat.isNative) {
                location.href = url;
            }
            else {
                this.backToNativeWithTransparent(urlBack);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.rule-box {
    width: 221px;
    height: 350px;
    position: relative;

    .content {
        width: 100%;
        height: 292px;
        position: relative;
        background-image: url('../../../../assets/rulesBg.png');
        background-size: 100% 100%;
        overflow-y: scroll;
        .main-content {
            width: 174px;
            height: 202px;
            position: absolute;
            top: 43px;
            left: 22px;
            overflow: hidden;
            overflow-y: scroll;
            box-sizing: border-box;
        }

        .service {
            width: 130px;
            height: 25px;
            position: absolute;
            left: 45px;
            top: 257px;
        }
        .content-text {
            p {
                font-size: 10px;
                font-family: PingFang SC;
                color: #333;
                line-height: 20px;
                text-align: justify;
            }
        }
    }
    .closeBtn {
        width: 28px;
        height: 28px;
        background-image: url('../../../../assets/closeBtn.png');
        background-size: 100% 100%;
        position: absolute;
        left: 96px;
        bottom: 0;
    }
}
</style>
